import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';

export default mutatorAction('SET_EXPORT_LINK', (downloadLink: string) => {
    getStore().downloadLink = downloadLink;
});
